/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AnexoItemProdMatAliases {
  FETCH_TISS_OPME = 'fetch-tiss-opme',
  FETCH_TISS_QUIMIO = 'fetch-tiss-quimio',
  FIELD_CD_AUT_FUNCIONAMENTO = 'field-cdAutFuncionamento',
  FIELD_CD_REF_FABRICANTE_IMP = 'field-cdRefFabricanteImp',
  FIELD_DS_OPCAO_FABRICANTE = 'field-dsOpcaoFabricante',
  FIELD_DS_TIPO_ANEXO = 'field-dsTipoAnexo',
  FIELD_DS_TIPO_ANEXO_2 = 'field-dsTipoAnexo-2',
  FIELD_DS_UNIDADE_MEDIDA = 'field-dsUnidadeMedida',
  FIELD_DS_VIA_ADMINISTRACAO = 'field-dsViaAdministracao',
  FIELD_IE_FREQUENCIA_DOSE = 'field-ieFrequenciaDose',
  FIELD_NR_REGISTRO_ANVISA = 'field-nrRegistroAnvisa',
  FIELD_QT_DOSAGEM_TOTAL = 'field-qtDosagemTotal',
  FORM_TISS_OPME = 'form-tiss-opme',
  FORM_TISS_QUIMIO = 'form-tiss-quimio',
  INPUT_CD_AUT_FUNCIONAMENTO = 'input-cdAutFuncionamento',
  INPUT_CD_REF_FABRICANTE_IMP = 'input-cdRefFabricanteImp',
  INPUT_DS_OPCAO_FABRICANTE = 'input-dsOpcaoFabricante',
  INPUT_DS_TIPO_ANEXO = 'input-dsTipoAnexo',
  INPUT_DS_TIPO_ANEXO_2 = 'input-dsTipoAnexo-2',
  INPUT_DS_UNIDADE_MEDIDA = 'input-dsUnidadeMedida',
  INPUT_DS_VIA_ADMINISTRACAO = 'input-dsViaAdministracao',
  INPUT_IE_FREQUENCIA_DOSE = 'input-ieFrequenciaDose',
  INPUT_NR_REGISTRO_ANVISA = 'input-nrRegistroAnvisa',
  INPUT_QT_DOSAGEM_TOTAL = 'input-qtDosagemTotal',
  LAYOUT_ANEXO_ITEM_PROD_MAT = 'layout-anexo-item-prod-mat',
  PANEL_TISS_OPME = 'panel-tiss-opme',
  PANEL_TISS_QUIMIO = 'panel-tiss-quimio',
}
export { AnexoItemProdMatAliases };
